import React, {FC} from "react"
import styled, {css} from "styled-components"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import FormattedMessage, {FormattedCurrency} from "@irati/utils/lang"
import {H3} from "@irati/ui/src/Typography"
import Spacing from "@irati/ui/src/Spacing"
import {UserRedemptionReportSavingsData} from "@irati/types"
import {Separator, StyledMenu} from "../WalletMenu/Menu"

interface Props {
  savings?: UserRedemptionReportSavingsData
}

const MySavingsHeaderWidget: FC<Props> = ({savings}) => {
  return (
    <StyledMenu>
      <Icon
        icon={IconTypes.savingsAnimated}
        size={28}
        aria-label="Illustration of a stack of dollar bills next to the text 'NO SAVINGS YET'."
      />
      {savings?.value ? (
        <>
          <Separator />
          <Flex direction="column">
            <CustomHeader>
              <FormattedMessage id="platform.mySavings.header.copy" />
            </CustomHeader>
            <H3 as="span" marginTop={-0.5}>
              <FormattedCurrency
                currency={savings?.currency || ""}
                value={savings?.value || 0}
                maximumFractionDigits={savings?.value ? 2 : 0}
              />
            </H3>
          </Flex>
        </>
      ) : (
        <Spacing marginLeft={0.5}>
          <CustomHeader>
            <FormattedMessage id="platform.mySavings.zeroState.title" />
          </CustomHeader>
        </Spacing>
      )}
    </StyledMenu>
  )
}

export default MySavingsHeaderWidget

const CustomHeader = styled.span`
  ${({theme}) => css`
    font-family: ${theme.font.bold};
    font-size: 8px;
    text-transform: uppercase;
    color: ${theme.colors.greys.black};
  `}
`
